module.exports = __webpack_public_path__ + "img/vn_vn1.e75b0cf5.png";